// extracted by mini-css-extract-plugin
module.exports = {"mob_nav":"_iJ","df":"_iK","bold":"_iL","ask__btn":"_iM","nav_list__item":"_iN","mob_nav__link":"_iO","counter":"_iP","mob_nav__active_teacher":"_iQ","search":"_iR"};